/**
 * @param {Object} selectedProject - The destination project (from the list)
 * @param {Object} originProject - The current project being scheduled (from Redux state.project)
 * @param {Object} directionsLibraries - Google Maps services
 */
export default function updateDirections(selectedProject, originProject, directionsLibraries) {
  return function () {
    if (!selectedProject.id) return
    
    // CHANGED: We now check originProject directly, not state.project
    if (!originProject || !originProject.id) {
      console.log('no project selected to compare against')
      return
    }

    const {directionsService, directionsRenderer} = directionsLibraries
    if (!directionsService || !directionsRenderer) {
      console.log('google libraries not loaded yet')
      return
    }

    directionsService.route(
      {
        // CHANGED: Access site directly from the passed project object
        origin: originProject.site.geocode_results.geometry.location,
        destination: selectedProject.site.geocode_results.geometry.location,
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (response, status) => {
        if (status === 'OK') directionsRenderer.setDirections(response)
        else console.log('directions request failed: ', status)
      }
    )
  }
}